import React, { useEffect, useState} from 'react'
import {useParams} from 'react-router-dom';
import { Button } from 'antd';
import moment from 'moment'
import BillingService from '../../../services/billing';
import "./Print.css"

export const Print = () => {

    const params = useParams();
    const [invoice, setInvoice] = useState();
    const [client, setClient] = useState();
    const [redeem, setReedem] = useState();
    const [promotion, setPromotion] = useState();
    const [date, setDate] = useState();
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        let data =  {id: params.id};
        BillingService.getInvoice(data).then(
          (response) => {
            console.log(response);
            setInvoice(response.data.visit);
            setClient(response.data.client);
            setReedem(response.data.redeem);
            setPromotion(response.data.promotion);
            setDate(moment(new Date(response.data.visit.fecha_visita)).format('DD-MM-YYYY HH:MM:s'));
            setIsLoaded(true);
          },
          (error) => {
              // console.log(error.response.data.message)
          }
        );
    }, [])
    

    return (
        <>
            { isLoaded &&
            <div className='print' id="print">
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img src="https://coopegas.com/wp-content/uploads/2020/10/logo.jpg" alt="Logo"/>

                </div>
                <p className="centered bold">Cooperativa De Producción y Servicios Múltiples La Económica, INC</p>
                <p className="centered">RNC: 4-0105258-1</p>
                <p className="centered bold">Factura al Contado  </p>
                
                

                <table>
                    <thead>
                        <tr>
                            <th className="description ">No. Fact.</th>
                            <th className="description"></th>
                            <th className="description">Moneda</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="description centered">FTC{invoice.id_visita}</td>
                            <td className="description centered"></td>
                            <td className="description centered">DOP</td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <p> <b>Cliente: </b>{client.nombre + ' '} {(client.apellido !== null) ? client.apellido : ''}</p>
                <p><b>Fecha:</b> {date} </p>
                {/* <p><b>Hora:</b> {date.getHours() + ':' + date.getMinutes()}</p> */}

                <br/>
                <table>
                    <thead>
                        <tr>
                            <th className="description">Cant.</th>
                            <th className="description">Descripción</th>
                            <th className="description">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="description centered">{invoice.cantidad_galones}</td>
                            <td className="description centered">GAS</td>
                            <td className="description centered">${invoice.precio_gasolina}</td>
                        </tr>

                        <tr>
                            <td className="description "></td>
                            <td className="description centered">TOTAL</td>
                            <td className="description centered">${(parseFloat(invoice.cantidad_galones) * invoice.precio_gasolina).toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <p className="centered">Puntos generados: <b>{Number(invoice.cantidad_galones) >= 5 ? promotion.valor : 0}</b></p>
                <p className="centered">Total de Puntos: <b>{ (client.codigo === '22222') ? 0 : Number(redeem.restantes).toFixed(2)}</b> </p>
                <hr/>
                <p className="centered">Gracias por su compra</p>
                <br/>
                <Button type='primary' className='print-btn' onClick={() => window.print()} >Imprimir</Button>
            </div> }
        </>
    )
}
